var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-6 container-background", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.formValid,
            callback: function ($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid",
          },
        },
        [
          _c("v-card", { staticClass: "main-card pa-6 mb-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-center justify-space-between flex-wrap",
              },
              [
                _c("div", [
                  _c(
                    "h1",
                    { staticClass: "main-title" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "rgb(204 33 40)" },
                        },
                        [_vm._v(" mdi-form-select ")]
                      ),
                      _vm._v(" Configuración del formulario "),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "main-subtitle" }, [
                    _vm._v(
                      " Personaliza el título, logo y política de tratamiento de datos del formulario. "
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "v-card",
            { staticClass: "section-card pa-6 mb-6" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c(
                  "div",
                  { staticClass: "section-icon" },
                  [
                    _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v(" mdi-domain "),
                    ]),
                  ],
                  1
                ),
                _c("div", [
                  _c("h2", { staticClass: "section-title" }, [
                    _vm._v(" Información general "),
                  ]),
                  _c("p", { staticClass: "section-subtitle" }, [
                    _vm._v(" Configura la identidad visual del formulario. "),
                  ]),
                ]),
              ]),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("label", { staticClass: "custom-label" }, [
                        _vm._v(" Título del formulario "),
                      ]),
                      _c("v-text-field", {
                        staticClass: "custom-input",
                        attrs: {
                          outlined: "",
                          dense: "",
                          placeholder: "Ej: Registro de clientes",
                          rules: [_vm.rules.required],
                        },
                        model: {
                          value: _vm.formTitle,
                          callback: function ($$v) {
                            _vm.formTitle = $$v
                          },
                          expression: "formTitle",
                        },
                      }),
                      _c("small", { staticClass: "helper-text" }, [
                        _vm._v(
                          " Este será el título visible para el adquiriente. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("label", { staticClass: "custom-label" }, [
                        _vm._v(" Logo del comercio "),
                      ]),
                      _c("v-file-input", {
                        staticClass: "custom-input",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "prepend-inner-icon": "mdi-image-outline",
                          accept: "image/png, image/jpeg, image/webp",
                          label: "Seleccionar logo",
                          multiple: false,
                          rules: [_vm.rules.logo],
                        },
                        model: {
                          value: _vm.logo,
                          callback: function ($$v) {
                            _vm.logo = $$v
                          },
                          expression: "logo",
                        },
                      }),
                      _c("small", { staticClass: "helper-text d-block mb-4" }, [
                        _vm._v(
                          " Tamaño recomendado del logo: 300 × 160 px. Formatos permitidos: WEBP, PNG o JPG. "
                        ),
                      ]),
                      _vm.existImage
                        ? _c("div", { staticClass: "logo-preview" }, [
                            _c("img", {
                              staticClass: "logo-image",
                              attrs: { src: _vm.imageLogo, alt: "Logo" },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
            _c("div", { staticClass: "section-header" }, [
              _c(
                "div",
                { staticClass: "section-icon" },
                [
                  _c("v-icon", { attrs: { color: "white" } }, [
                    _vm._v(" mdi-shield-check-outline "),
                  ]),
                ],
                1
              ),
              _c("div", [
                _c("h2", { staticClass: "section-title" }, [
                  _vm._v(" Política Habeas Data "),
                ]),
                _c("p", { staticClass: "section-subtitle" }, [
                  _vm._v(
                    " Configura el contenido legal y el enlace de tratamiento de datos. "
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "mt-6" },
              [
                _c("label", { staticClass: "custom-label" }, [
                  _vm._v(" Texto legal "),
                ]),
                _c("v-textarea", {
                  staticClass: "custom-input",
                  attrs: {
                    outlined: "",
                    "auto-grow": "",
                    rows: "5",
                    counter: "2000",
                    maxlength: "2000",
                    placeholder: "Escriba aquí el texto legal...",
                    rules: [_vm.rules.required],
                  },
                  model: {
                    value: _vm.legalText,
                    callback: function ($$v) {
                      _vm.legalText = $$v
                    },
                    expression: "legalText",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c("label", { staticClass: "custom-label" }, [
                  _vm._v(" Texto resaltado "),
                ]),
                _c("v-text-field", {
                  staticClass: "custom-input",
                  attrs: {
                    outlined: "",
                    dense: "",
                    placeholder: "Ej: clic aquí",
                    rules: [_vm.rules.required],
                  },
                  model: {
                    value: _vm.highlightText,
                    callback: function ($$v) {
                      _vm.highlightText = $$v
                    },
                    expression: "highlightText",
                  },
                }),
                _c("small", { staticClass: "helper-text" }, [
                  _vm._v(
                    " Este texto llevará al enlace de política de datos. "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("v-card", { staticClass: "section-card pa-6 mb-6" }, [
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c("label", { staticClass: "custom-label" }, [
                  _vm._v(" URL política de datos "),
                ]),
                _c("v-text-field", {
                  staticClass: "custom-input",
                  attrs: {
                    outlined: "",
                    dense: "",
                    "prepend-inner-icon": "mdi-link-variant",
                    placeholder: "https://",
                    rules: [_vm.rules.required, _vm.rules.url],
                  },
                  model: {
                    value: _vm.policyUrl,
                    callback: function ($$v) {
                      _vm.policyUrl = $$v
                    },
                    expression: "policyUrl",
                  },
                }),
                _c("small", { staticClass: "helper-text" }, [
                  _vm._v(
                    " Este enlace será asignado automáticamente al texto resaltado. "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6" } },
                [
                  _vm.showAlert
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "my-4",
                          attrs: {
                            type: _vm.alertType,
                            border: "left",
                            "colored-border": "",
                            elevation: "2",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text px-10 font-weight-bold",
                  attrs: {
                    color: "rgb(204 33 40)",
                    "x-large": "",
                    elevation: "2",
                    rounded: "",
                  },
                  on: { click: _vm.formUserByCompanySave },
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(" mdi-content-save-outline "),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isEditing
                          ? "Actualizar configuración"
                          : "Guardar configuración"
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.6", "z-index": "9999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }